"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pharmacyHandlers = exports.getDomainPharmacy = exports.getPharmacyAppointmentOptions = exports.searchPharmacy = exports.mockPharmacy = exports.getPharmacy = void 0;
var instance_1 = require("./instance");
var msw_1 = require("msw");
var mock = {};
function getPharmacy(pharmId) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/Pharmacy",
        method: "GET",
        params: { pharmId: pharmId },
    })
        .then(function (result) { return result.data; });
}
exports.getPharmacy = getPharmacy;
exports.mockPharmacy = {
    id: 591,
    address: {
        street1: "3205 E. Southlake Blvd.",
        street2: null,
        city: "Southlake",
        state: "TX",
        zip: "76092",
    },
    businessHours: [
        { day: "Sunday", open: "08:00:00", close: "21:00:00" },
        { day: "Monday", open: "08:00:00", close: "21:00:00" },
        { day: "Tuesday", open: "08:30:00", close: "18:30:00" },
        { day: "Wednesday", open: "08:30:00", close: "18:30:00" },
        { day: "Thursday", open: "00:00:00", close: "21:59:00" },
        { day: "Saturday", open: "11:00:00", close: "23:00:00" },
    ],
    leadTimeBuffer: 60,
    closingTimeBuffer: 60,
    name: "Medsavers Pharmacy",
    phone: "7834346236",
    brandColor: "#b00002",
    storeImageUrl: "https://via.placeholder.com/300x500",
    storeLogoUrl: "https://via.placeholder.com/500x300",
    timeZone: {
        displayName: "(UTC-06:00) Central Time (US & Canada)",
        standardName: "Central Standard Time",
        baseUtcOffset: "-06:00:00",
    },
    latitude: 32.938371,
    longitude: -97.101032,
    extraInfoList: [
        {
            infoImageUrl: null,
            title: "Safety Informaton",
            description: "Safety required to disinfect surfaces between visits. Safety dividers at checkout",
        },
        {
            infoImageUrl: "https://via.placeholder.com/300x500",
            title: "Lorem Ipsum",
            description: "Safety required to disinfect surfaces between visits. Safety dividers at checkout",
        },
    ],
    chatEnabled: true,
    appointmentsEnabled: true,
    progressEnabled: true,
    rx365Enabled: true,
    medicationRemindersEnabled: true,
    expressQRCodesEnabled: true,
    vaccinationsPerVisit: 2,
};
mock.getPharmacy = function () {
    return msw_1.rest.get("".concat((0, instance_1.getBaseURL)(), "/Pharmacy"), function (req, res, ctx) {
        return res(ctx.status(200), ctx.json(exports.mockPharmacy));
    });
};
var searchPharmacyData = [
    {
        id: 591,
        address: {
            street1: "3205 E. Southlake Blvd.",
            street2: null,
            city: "Southlake",
            state: "TX",
            zip: "76092",
        },
        businessHours: [
            { day: "Sunday", open: "08:00", close: "21:00" },
            { day: "Monday", open: "08:00", close: "21:00" },
            { day: "Tuesday", open: "08:00", close: "21:00" },
            { day: "Wednesday", open: "08:00", close: "21:00" },
            { day: "Thursday", open: "08:00", close: "21:00" },
            { day: "Friday", open: "08:00", close: "21:00" },
            { day: "Saturday", open: "08:00", close: "21:00" },
        ],
        leadTimeBuffer: 15,
        closingTimeBuffer: 30,
        name: "Medsavers Pharmacy",
        phone: "7834346236",
        brandColor: "#b00002",
        storeImageUrl: "https://via.placeholder.com/150",
        storeLogoUrl: "https://via.placeholder.com/300",
        timeZone: {
            displayName: "(UTC-06:00) Central Time (US & Canada)",
            standardName: "Central Standard Time",
            baseUtcOffset: "-06:00:00",
        },
        latitude: 32.938371,
        longitude: -97.101032,
        extraInfoList: null,
        chatEnabled: true,
        appointmentsEnabled: true,
        progressEnabled: true,
        medicationRemindersEnabled: true,
        rx365Enabled: true,
        vaccinationsPerVisit: 2,
    },
    {
        id: 9082,
        address: {
            street1: "3205 E. Southlake Blvd.",
            street2: null,
            city: "Southlake",
            state: "TX",
            zip: "76092",
        },
        businessHours: [
            { day: "Sunday", open: "08:00", close: "21:00" },
            { day: "Monday", open: "08:00", close: "21:00" },
            { day: "Tuesday", open: "08:00", close: "21:00" },
            { day: "Wednesday", open: "08:00", close: "21:00" },
            { day: "Thursday", open: "08:00", close: "21:00" },
            { day: "Friday", open: "08:00", close: "21:00" },
            { day: "Saturday", open: "08:00", close: "21:00" },
        ],
        leadTimeBuffer: 15,
        closingTimeBuffer: 30,
        name: "Apothecary Pharmacy",
        phone: "7834346236",
        brandColor: "#b00002",
        storeImageUrl: "https://via.placeholder.com/150",
        storeLogoUrl: "https://via.placeholder.com/300",
        timeZone: {
            displayName: "(UTC-06:00) Central Time (US & Canada)",
            standardName: "Central Standard Time",
            baseUtcOffset: "-06:00:00",
        },
        latitude: 32.938371,
        longitude: -97.101032,
        extraInfoList: null,
        chatEnabled: true,
        appointmentsEnabled: true,
        progressEnabled: true,
        rx365Enabled: true,
        medicationRemindersEnabled: true,
        vaccinationsPerVisit: 2,
    },
    {
        id: 2034,
        address: {
            street1: "3205 E. Southlake Blvd.",
            street2: null,
            city: "Southlake",
            state: "TX",
            zip: "76092",
        },
        businessHours: [
            { day: "Sunday", open: "08:00", close: "21:00" },
            { day: "Monday", open: "08:00", close: "21:00" },
            { day: "Tuesday", open: "08:00", close: "21:00" },
            { day: "Wednesday", open: "08:00", close: "21:00" },
            { day: "Thursday", open: "08:00", close: "21:00" },
            { day: "Friday", open: "08:00", close: "21:00" },
            { day: "Saturday", open: "08:00", close: "21:00" },
        ],
        leadTimeBuffer: 15,
        closingTimeBuffer: 30,
        name: "Medicine Dispenser Pharmacy",
        phone: "7834346236",
        brandColor: "#b00002",
        storeImageUrl: "https://via.placeholder.com/150",
        storeLogoUrl: "https://via.placeholder.com/300",
        timeZone: {
            displayName: "(UTC-06:00) Central Time (US & Canada)",
            standardName: "Central Standard Time",
            baseUtcOffset: "-06:00:00",
        },
        latitude: 32.938371,
        longitude: -97.101032,
        extraInfoList: null,
        chatEnabled: true,
        appointmentsEnabled: true,
        progressEnabled: true,
        rx365Enabled: true,
        medicationRemindersEnabled: true,
        vaccinationsPerVisit: 3,
    },
    {
        id: 23,
        address: {
            street1: "3205 E. Southlake Blvd.",
            street2: null,
            city: "Southlake",
            state: "TX",
            zip: "76092",
        },
        businessHours: [
            { day: "Sunday", open: "08:00", close: "21:00" },
            { day: "Monday", open: "08:00", close: "21:00" },
            { day: "Tuesday", open: "08:00", close: "21:00" },
            { day: "Wednesday", open: "08:00", close: "21:00" },
            { day: "Thursday", open: "08:00", close: "21:00" },
            { day: "Friday", open: "08:00", close: "21:00" },
            { day: "Saturday", open: "08:00", close: "21:00" },
        ],
        leadTimeBuffer: 15,
        closingTimeBuffer: 30,
        name: "Deeds Done Dirt Cheap Pharmacy",
        phone: "7834346236",
        brandColor: "#b00002",
        storeImageUrl: "https://via.placeholder.com/150",
        storeLogoUrl: "https://via.placeholder.com/300",
        timeZone: {
            displayName: "(UTC-06:00) Central Time (US & Canada)",
            standardName: "Central Standard Time",
            baseUtcOffset: "-06:00:00",
        },
        latitude: 32.938371,
        longitude: -97.101032,
        extraInfoList: null,
        chatEnabled: false,
        appointmentsEnabled: false,
        progressEnabled: false,
        rx365Enabled: true,
        medicationRemindersEnabled: true,
        vaccinationsPerVisit: 1,
    },
    {
        id: 964,
        address: {
            street1: "3205 E. Southlake Blvd.",
            street2: null,
            city: "Southlake",
            state: "TX",
            zip: "76092",
        },
        businessHours: [
            { day: "Sunday", open: "08:00", close: "21:00" },
            { day: "Monday", open: "08:00", close: "21:00" },
            { day: "Tuesday", open: "08:00", close: "21:00" },
            { day: "Wednesday", open: "08:00", close: "21:00" },
            { day: "Thursday", open: "08:00", close: "21:00" },
            { day: "Friday", open: "08:00", close: "21:00" },
            { day: "Saturday", open: "08:00", close: "21:00" },
        ],
        leadTimeBuffer: 15,
        closingTimeBuffer: 30,
        name: "Pill Dispenser Pharmacy",
        phone: "7834346236",
        brandColor: "#b00002",
        storeImageUrl: "https://via.placeholder.com/150",
        storeLogoUrl: "https://via.placeholder.com/300",
        timeZone: {
            displayName: "(UTC-06:00) Central Time (US & Canada)",
            standardName: "Central Standard Time",
            baseUtcOffset: "-06:00:00",
        },
        latitude: 32.938371,
        longitude: -97.101032,
        extraInfoList: null,
        chatEnabled: true,
        appointmentsEnabled: true,
        progressEnabled: true,
        rx365Enabled: true,
        medicationRemindersEnabled: true,
        vaccinationsPerVisit: 2,
    },
];
var getMatchingPharmacies = function (searchText) {
    if (!searchText || searchText.trim() === "")
        return searchPharmacyData;
    return searchPharmacyData.filter(function (pharmacy) {
        return pharmacy.name
            .trim()
            .toLowerCase()
            .search(searchText.trim().toLowerCase()) !== -1 ||
            pharmacy.phone
                .trim()
                .toLowerCase()
                .search(searchText.trim().toLowerCase()) !== -1;
    });
};
function searchPharmacy(_a) {
    var searchText = _a.searchText, isWebSearch = _a.isWebSearch;
    return (0, instance_1.getInstance)()
        .request({
        url: "/Pharmacy/search",
        method: "GET",
        params: { searchText: searchText, isWebSearch: isWebSearch },
    })
        .then(function (result) { return result.data; });
}
exports.searchPharmacy = searchPharmacy;
mock.searchPharmacy = function () {
    return msw_1.rest.get("".concat((0, instance_1.getBaseURL)(), "/Pharmacy/search"), function (req, res, ctx) {
        var searchText = req.url.searchParams.get("searchText");
        return res(ctx.status(200), ctx.json(getMatchingPharmacies(searchText)));
    });
};
function getPharmacyAppointmentOptions() {
    return (0, instance_1.getInstance)()
        .request({
        url: "/Pharmacy/appointment-options",
        method: "GET",
    })
        .then(function (result) { return result.data; });
}
exports.getPharmacyAppointmentOptions = getPharmacyAppointmentOptions;
mock.getPharmacyAppointmentOptions = function () {
    return msw_1.rest.get("".concat((0, instance_1.getBaseURL)(), "/Pharmacy/appointment-options"), function (req, res, ctx) {
        return res(ctx.delay(2000), ctx.status(200), ctx.json({
            vaccination: [
                {
                    title: "Flu Vaccination",
                    id: 123,
                },
                {
                    title: "Covid 10th Booster",
                    id: 125,
                },
            ],
            clinical: [
                {
                    title: "Weight Management",
                    id: 122,
                },
            ],
            other: [
                {
                    title: "Blood Pressure",
                    id: 120,
                },
            ],
        }));
    });
};
function getDomainPharmacy(subdomain) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/SubDomain",
        method: "GET",
        params: { subdomain: subdomain },
    })
        .then(function (result) { return result.data; });
}
exports.getDomainPharmacy = getDomainPharmacy;
mock.getDomainPharmacy = function () {
    return msw_1.rest.get("".concat((0, instance_1.getBaseURL)(), "/SubDomain"), function (req, res, ctx) {
        var _a, _b;
        var domain = (_a = req.url.searchParams.get("subdomain")) !== null && _a !== void 0 ? _a : "";
        var domainMappings = {
            "localhost:3000": exports.mockPharmacy,
        };
        return res(ctx.status(200), ctx.json((_b = domainMappings[domain]) !== null && _b !== void 0 ? _b : exports.mockPharmacy));
    });
};
exports.pharmacyHandlers = mock;
